import moment from 'moment';

/**
 * Formats a number with comma separators for thousands
 * @param value - The value to format
 * @returns The formatted string or the original value if not a number
 */
export const formatNumberWithCommas = (value: any): string => {
  if (value === undefined || value === null) return "";
  // Convert to number if it's a string
  const numValue = typeof value === "string" ? Number.parseFloat(value) : value;
  // Check if it's a valid number
  if (Number.isNaN(numValue)) {
    return String(value);
  }
  // Use locale grouping to avoid regex backtracking risks.
  return Number(numValue).toLocaleString("en-US", {
    useGrouping: true,
    maximumFractionDigits: 20,
  });

};

/**
 * Formats a date range for delivery period display
 * @param start - Start date
 * @param end - End date
 * @returns Formatted date range string
 */
export const formatDeliveryPeriod = (start: string | Date, end: string | Date): string => {
  if (!start || !end) return "";
  
  const startDate = moment(start);
  const endDate = moment(end);

  return `${startDate.format("DD/MM/YYYY")} - ${endDate.format("DD/MM/YYYY")}`;
};